module.exports = Em.Handlebars.compile("<div class=\"loading-screen\">\n    <app-logo-component {{bind-attr text=text}} />\n</div>\n");